import React, { Component } from 'react';

import Aux from '../../hoc/Aux';
import WizardStepCountry from './Steps/WizardStepCountry';
import WizardStepFwk from './Steps/WizardStepFwk';
import WizardStepLocation from './Steps/WizardStepLocation';
import WizardStepExecutionType from './Steps/WizardStepExecutionType';
import WizardStepMediumTypes from './Steps/WizardStepMediumTypes';
import WizardStepProductSystem from './Steps/WizardStepProductSystem';
import WizardStepProductSystemItems from './Steps/WizardStepProductSystemItems';
import WizardStepProductSystemItemsByUid from './Steps/WizardStepProductSystemItemsByUid';

// redux
import { connect } from 'react-redux';


class Wizard extends Component {

    render () {
        return (
            <Aux>
              <div className="container">
                <WizardStepCountry
                  currentStep={this.props.currentStep}
                  selectedSteps={this.props.selectedSteps}
                />
                <WizardStepFwk
                  currentStep={this.props.currentStep}
                  selectedSteps={this.props.selectedSteps}
                  />
                <WizardStepLocation
                  currentStep={this.props.currentStep}
                  selectedSteps={this.props.selectedSteps}
                  />
                <WizardStepExecutionType
                  currentStep={this.props.currentStep}
                  selectedSteps={this.props.selectedSteps}
                  />
                <WizardStepMediumTypes
                  currentStep={this.props.currentStep}
                  selectedSteps={this.props.selectedSteps}
                  />
                <WizardStepProductSystem
                  currentStep={this.props.currentStep}
                  selectedSteps={this.props.selectedSteps}
                  />
                <WizardStepProductSystemItems
                  currentStep={this.props.currentStep}
                  selectedSteps={this.props.selectedSteps}
                  />
                <WizardStepProductSystemItemsByUid
                  currentStep={this.props.currentStep}
                  selectedSteps={this.props.selectedSteps}
                  />
              </div>
            </Aux>
        );
    }
}

const mapStateToProps = state => {
  return {
    selectedSteps: state.wizard.selectedSteps,
    currentStep: state.wizard.currentStep,
  };
}

const mapDispatchToProps = dispatch => {
  return {
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Wizard);



// WEBPACK FOOTER //
// ./src/components/Wizard/Wizard.js